import { createSlice } from "@reduxjs/toolkit";

const sshhSlice = createSlice({
  name: "asist",
  initialState: {
    register: localStorage.getItem("registerStatus") ? localStorage.getItem("registerStatus") : [],
    error: null,
    loading: false,
  },
  reducers: {
    addSSHHStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addSSHHSuccess: (state, action) => {
      state.loading = false;
      state.register = action.payload;
      localStorage.setItem("registerStatus", action.payload);
    },
    addSSHHFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  addSSHHStart,
  addSSHHSuccess,
  addSSHHFailure,
} = sshhSlice.actions;

export default sshhSlice.reducer;